module.exports = __webpack_public_path__ + "static/media/heroimg-2.0730614e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/main/heroimg-2.jpg
// module id = 63
// module chunks = 0